export default __webpack_public_path__ + "static/media/webberUsbLogo.d05632f8.png";